import React, { useEffect } from 'react';
import axios from 'axios';
import { Row, Col, FormGroup, Label, Input } from 'reactstrap';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import API_BASE_URL from '../../../../Config/api';
import { COUNTRIES } from '../../../../Constant/countries';
const OrderHeaderFields = ({ formData, setFormData, isReadOnly }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleEmailKeyUp = async (e) => {
 
    const email = e.target.value;
    if (email && email.includes('@')) {
      try {
        console.log("email>>",email)
        const res = await axios.post(`${API_BASE_URL}/api/get-customer`, { email });
        console.log("email2>>",email)
        if (res.data && res.data.customer) {
          setFormData((prev) => ({
            ...prev,
            ...res.data.customer,
          }));
        }
      } catch (error) {
        console.error('Customer lookup failed:', error.message);
      }
    }
  };

  return (
    <Row className="mb-4">
      <Row className="mb-3 align-items-center">
        <Col md="2">
            <Label for="email" className="mb-0">Email</Label>
        </Col>
        <Col md="10">
            <Input
            type="text"
            name="email"
            id="email"
            value={formData.email}
            onChange={handleChange}
            onKeyUp={handleEmailKeyUp}
            readOnly={isReadOnly}
            required
            />
        </Col>
      </Row>
      <Row className="mb-3 align-items-center">
        <Col md="2">
            <Label for="store_name" className="mb-0">Store Name</Label>
        </Col>
        <Col md="10">
            <Input
            type="text"
            name="store_name"
            id="store_name"
            value={formData.store_name}
            onChange={handleChange}
            readOnly={false}
            required
            />
        </Col>
      </Row>
      <Row className="mb-3 align-items-center">
        <Col md="2">
            <Label for="shipping_address" className="mb-0">Shipping Address</Label>
        </Col>
        <Col md="10">
            <Input
            type="text"
            name="shipping_address"
            id="shipping_address"
            value={formData.shipping_address}
            onChange={handleChange}
            readOnly={false}
            required
            />
        </Col>
      </Row>
      <Row className="mb-3 align-items-center">
        <Col md="2">
            <Label for="billing_address" className="mb-0">Billing Address (If Different)</Label>
        </Col>
        <Col md="10">
            <Input
            type="text"
            name="billing_address"
            id="billing_address"
            value={formData.billing_address}
            onChange={handleChange}
            readOnly={false}
            
            />
        </Col>
      </Row>
      <Row className="mb-3 align-items-center">
        <Col md="2">
            <Label for="vat_eori" className="mb-0">VAT + EORI Number</Label>
        </Col>
        <Col md="10">
            <Input
            type="text"
            name="vat_eori"
            id="vat_eori"
            value={formData.vat_eori}
            onChange={handleChange}
            readOnly={false}

            required
            />
        </Col>
      </Row>
      
      <Row className="mb-3 align-items-center">
        <Col md="2">
            <Label for="tel" className="mb-0">Tel</Label>
        </Col>
        <Col md="10">
            <Input
            type="text"
            name="tel"
            id="tel"
            value={formData.tel}
            onChange={handleChange}
            readOnly={false}

            required
            />
        </Col>
      </Row>
      <Row className="mb-3 align-items-center">
        <Col md="2">
            <Label for="country" className="mb-0">Delivery Country</Label>
        </Col>
        <Col md="10">
            <Input
            type="select"
            name="country"
            id="country"
            value={formData.country || ''}
            onChange={handleChange}
            >
              <option value="">Select country…</option>
              {COUNTRIES.map((c) => <option key={c} value={c}>{c}</option>)}
            </Input>
        </Col>
      </Row>
      <Row className="mb-3 align-items-center">
        <Col md="2">
            <Label for="order_date" className="mb-0">Order Date</Label>
        </Col>
        <Col md="10">
      <DatePicker
        selected={formData.order_date ? new Date(formData.order_date) : null}
        onChange={(date) =>
          handleChange({ target: { name: 'order_date', value: date } })
        }
        className="form-control"
        dateFormat="yyyy-MM-dd"
        placeholderText="Select order date"
        readOnly={false}
      />
    </Col>
      </Row>
      <Row className="mb-3 align-items-center">
        <Col md="2">
            <Label for="showroom" className="mb-0">Showroom</Label>
        </Col>
        <Col md="10">
            <Input
            type="text"
            name="showroom"
            id="showroom"
            value={formData.showroom}
            onChange={handleChange}
            readOnly={false}
            />
        </Col>
      </Row>
      
      <Row className="mb-3 align-items-center">
        <Col md="2">
            <Label for="preferred_delivery_date" className="mb-0">Preferred Delivery Date</Label>
        </Col>
        <Col md="10">
            <DatePicker
              selected={formData.preferred_delivery_date ? new Date(formData.preferred_delivery_date) : null}
              onChange={(date) =>
                handleChange({ target: { name: 'preferred_delivery_date', value: date } })
              }
              className="form-control"
              dateFormat="yyyy-MM-dd"
              placeholderText="Select preferred delivery date"
              readOnly={false}
            />
        </Col>
      </Row>

    </Row>
  );
};

export default OrderHeaderFields;
